import { Location } from "history";
import React from "react";
import cookie from "react-cookies";

/**
 *
 * Extract query parameter from the current URL
 * And save it in a cookie
 * EG: https://www.3et.com/?promoCode=3ET100
 * @param {Location} location - The location object from React Router, containing the current URL information.
 * @param {queryParam} queryParam - The param to be extracted, eg promoCode
 */
const useSetQueryParam = (location: Location, queryParam: string) => {
  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryParamValue = queryParams.get(queryParam);

    if (queryParamValue) {
      cookie.save(queryParam, queryParamValue, {
        path: "/",
      });
    }
  }, [location, queryParam]);
};

export default useSetQueryParam;
